export default __webpack_public_path__ + "static/media/mana8.c43a40ec.svg";